import { oc } from '@orpc/contract';
import { getVehicleInputSchema, vehicleDetailSchema } from '../schemas/vehicles.schemas.js';
/** One round trip for the whole dossier: facts, inspection, valuation, costs, trade-in and provenance. */
export const getVehicleContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}',
    tags: ['Vehicles'],
    summary: 'Read one stock vehicle',
})
    .input(getVehicleInputSchema)
    .output(vehicleDetailSchema);
//# sourceMappingURL=get-vehicle.contract.js.map